module.exports = __webpack_public_path__ + "img/logoAvalizeHorizontalBranca.0029c849.png";